/**
 * LCW Button
 * Mede a largura do label e seta a CSS variable --label-width no botão.
 * Necessário pra animação de "troca de lugar" no hover usar a largura
 * correta no transform: translateX().
 */
(function () {
  'use strict';

  function measureButton(btn) {
    const label = btn.querySelector('.lcw-button__label');
    if (!label) return;
    // Reset before measuring (caso transform esteja aplicado)
    btn.style.setProperty('--label-width', `${label.offsetWidth}px`);
  }

  function measureAll() {
    document
      .querySelectorAll('.lcw-button--arrow-animate')
      .forEach(measureButton);
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measureAll, { once: true });
  } else {
    measureAll();
  }

  // Re-measure on resize (debounced via rAF)
  let rafId = null;
  window.addEventListener('resize', () => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      measureAll();
      rafId = null;
    });
  });

  // Re-measure after fonts load (largura do texto pode mudar)
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(measureAll);
  }

  // Shopify theme editor: re-medir quando section é editada
  document.addEventListener('shopify:section:load', measureAll);
  document.addEventListener('shopify:section:reorder', measureAll);
  document.addEventListener('shopify:block:select', measureAll);
})();
